import React, {useEffect, useRef} from "react";
import css from './block1SearchFloor.module.scss'
import {observer} from "mobx-react";
import {makeAutoObservable, runInAction} from "mobx";
import GoodsType from "enum/GoodsType";
import goodsType, {goodsTypeEnumMap} from "enum/GoodsType";
import classNames from "classnames";
import * as Api from 'api/api'
import {useHistory} from "react-router-dom";
import MyRouter from "router/router";
import NewsMenuType from "enum/NewsMenuType";
import useMyStores from "hooks/useMyStores";
import MyRouterUtil from "utils/MyRouterUtil";
import {useBoolean} from "ahooks";
import useFetchNav from "@/hooks/useFetchNav";

const CategoryType = {
    SELF: 'self',
    PROMOTION: 'promotion'
}

class Store {
    curGoodsType = GoodsType.ALL
    keyword = ''
    hotSearchList = []
    categoryList = []
    curCategoryType = null
    curCategoryId = null

    goodsTypeListFlag = false
    hotSearchListFlag = false
    categoryListFlag = false;

    curHotSearchIndex = 0;
    curCategoryIndex = 0;


    _selfCategoryTreeList = []
    _pCategoryTreeMap = new Map()


    get categoryTreeList() {
        if (!this.curCategoryType || this.curCategoryId === null) {
            return []
        }

        return this.getInnerCategoryTreeList(this.curCategoryType, this.curCategoryId)
    }

    hasInnerCategoryTreeList(categoryType, pid) {
        if (categoryType === CategoryType.SELF) {
            return this._selfCategoryTreeList.length > 0
        } else if (categoryType === CategoryType.PROMOTION) {
            return this._pCategoryTreeMap.has(pid)
        }
    }

    getInnerCategoryTreeList(categoryType, pid) {
        if (categoryType === CategoryType.SELF) {
            return this._selfCategoryTreeList
        } else if (categoryType === CategoryType.PROMOTION) {
            return this._pCategoryTreeMap.get(pid)
        }
    }

    setInnerCategoryTreeList(categoryType, pid, treeList) {
        if (categoryType === CategoryType.SELF) {
            this._selfCategoryTreeList = treeList
        } else if (categoryType === CategoryType.PROMOTION) {
            return this._pCategoryTreeMap.set(pid, treeList)
        }
    }

    get showCategoryTreeList() {
        return this.categoryTreeList?.length > 0
    }

    get curHotSearch() {
        return this.hotSearchList?.[this.curHotSearchIndex]
    }

    get curCategory() {
        return this.categoryList?.[this.curCategoryIndex]
    }

    toggleCategoryListFlag() {
        this.categoryListFlag = !this.categoryListFlag
    }

    setKeyword(value) {
        this.keyword = value
    }

    setCurCategoryIndex(value) {
        this.curCategoryIndex = value
    }

    toggleGoodsTypeListFlag() {
        this.goodsTypeListFlag = !this.goodsTypeListFlag
    }

    setGoodsTypeListFlag(value) {
        this.goodsTypeListFlag = value
    }

    setHotSearchListFlag(value) {
        this.hotSearchListFlag = value
    }

    setCurHotSearchIndex(value) {
        this.curHotSearchIndex = value;
    }

    setCategoryListFlag(value) {
        this.categoryListFlag = value
    }

    setCategoryList(value) {
        this.categoryList = value;
    }

    setHotSearchList(value) {
        this.hotSearchList = value
    }

    constructor() {
        makeAutoObservable(this)
    }
}

class CartStore {

    flag = false;

    setFlag(value) {
        this.flag = value
    }

    toggleFlag() {
        this.flag = !this.flag
    }

    constructor() {
        makeAutoObservable(this)
    }
}

class DrawerStore {
    flag = false;
    curIndex = 0

    setCurIndex(value) {
        this.curIndex = value
    }

    setFlag(value) {
        this.flag = value
    }

    toggleFlag() {
        this.flag = !this.flag
    }


    constructor() {
        makeAutoObservable(this)
    }
}

const store = new Store();
const cartStore = new CartStore()
const drawerStore = new DrawerStore()

function useFetchHotSearchList({setHotSearchList}) {
    useEffect(() => {
        Api.hotSearchList({}).then(data => {
            setHotSearchList(data)
        })
    }, [])
}

function useFetchCategoryList({setCategoryList}) {

    useEffect(() => {
        Api.nav().then(nav => {
            Api.fetchPGoodsCategoryList({
                page: 1,
                size: 9,
                parentId: 0
            }).then(data => {
                let list = [];

                list = [
                    ...list,
                    {
                        categoryType: CategoryType.SELF,
                        pid: 0,
                        id: 0,
                        name: nav?.selfRun,
                        level: 0,
                    }
                ]

                list = [
                    ...list,
                    ...data.objectList.map(item => {
                        const {id, parentId: pid, name, level} = item;
                        return {
                            categoryType: CategoryType.PROMOTION,
                            pid,
                            id,
                            name,
                            level
                        }
                    })
                ]

                setCategoryList(list)
            })
        })
    }, []);
}

const Index = ({className}) => {

    const {data: nav} = useFetchNav()

    const history = useHistory();

    useFetchCategoryList({setCategoryList: (v) => store.setCategoryList(v)})
    useFetchHotSearchList({setHotSearchList: (v) => store.setHotSearchList(v)})

    const {user: userStore, login: loginStore, service: serviceStore} = useMyStores()

    const drawer = {
        drawerItemList: [
            {
                text: nav?.video,
                onClick: () => {
                    history.push({
                        pathname: `${MyRouter.News.realPath}?menuType=${NewsMenuType.VIDEO}`
                    })
                }
            },
            {
                text: nav?.myBrowseHistory,
                onClick: (e) => {
                    e.preventDefault();

                    if (!userStore.isLogin) {
                        loginStore.show = true
                    } else {
                        window.open(
                            MyRouter.basename + MyRouter.User.path + "?currentIndex=4"
                        )
                    }
                }
            },
            {
                text: nav?.myCollect,
                onClick: (e) => {
                    e.preventDefault()
                    window.open(
                        MyRouter.basename + MyRouter.User.path + "?currentIndex=2"
                    );
                }
            },
            {
                text: nav?.customerService,
                onClick: (e) => {
                    if (!userStore.isLogin) {
                        loginStore.show = true
                    } else {
                        serviceStore.show = true;
                    }
                }
            },
            {
                text: nav?.help,
                onClick: (e) => {
                    history.push({
                        pathname: MyRouter.Help.path
                    })
                }
            }
        ]
    }

    const toCategoryPage = ({categoryId}) => {
        MyRouterUtil.build({history}).toSearchPage({categoryId})
    }

    const fetchCategoryTree = async ({categoryType, pid}) => {
        await runInAction(async () => {
            let treeList = []
            const has = store.hasInnerCategoryTreeList(categoryType, pid)

            if (!has) {
                if (categoryType === CategoryType.SELF) {
                    treeList = await Api.fetchCategoryTreeList({pid})
                } else if (categoryType === CategoryType.PROMOTION) {
                    treeList = await Api.fetchPGoodsCategoryTreeList({pid}).then(data => data.map(item => ({
                        ...item,
                        pid: item.parentId
                    })))
                }

                store.setInnerCategoryTreeList(categoryType, pid, treeList)

                // store.categoryTreeList = treeList;
            }
        })
    }

    // useEffect(() => {
    //     console.log(`categoryTreeList:${JSON.stringify(store.categoryTreeList)}`)
    // }, [store.categoryTreeList.length]);

    // 去搜索页面
    const toSearchPage = ({keyword, goodsType, selfFlag}) => {
        MyRouterUtil.build({history})
            .toSearchPage({keyword, goodsType, selfFlag})
    }

    const [inputFocus, {set: setInputFocus}] = useBoolean(false)

    const closeCategoryListTimeoutIdRef = useRef(null)
    const showCategoryList = () => {
        runInAction(() => {
            if (closeCategoryListTimeoutIdRef.current) {
                clearTimeout(closeCategoryListTimeoutIdRef.current)
            }

            store.categoryListFlag = true
        })
    }

    const hideCategoryList = () => {
        runInAction(() => {
            closeCategoryListTimeoutIdRef.current = setTimeout(() => {
                store.categoryListFlag = false
            }, 100)
        })
    }

    return (
        <div className={classNames("search-floor", className, css.root)}>
            <button
                className={classNames(css.btnAllCat, {
                    [css.active]: store.categoryListFlag
                })}
                onMouseOver={showCategoryList}
                onMouseOut={hideCategoryList}
            >
                所有分类
            </button>
            {
                store.categoryListFlag &&
                <div
                    className={css.categoryListPanel}
                    onMouseOver={showCategoryList}
                    onMouseOut={hideCategoryList}
                >
                    <div className={css.categoryListPanelContainer}>
                        <div className={css.categoryList}>
                            {
                                store.categoryList.map((item, i) => {
                                    const {categoryType, pid, id, name} = item;
                                    const active = i === store.curCategoryIndex

                                    let dom;
                                    if (active) {
                                        dom = (
                                            <div className={css.wrapper}>
                                                <div className={css.text}>
                                                    {name}
                                                </div>
                                                <img className={css.arrow} alt=''
                                                     src={require('./img/分类箭头右active.png')}/>
                                            </div>
                                        )
                                    } else {
                                        dom = (
                                            <>
                                                <div className={css.text}>
                                                    {name}
                                                </div>
                                                <img className={css.arrow} alt=''
                                                     src={require('./img/分类箭头右.png')}/>
                                            </>
                                        )
                                    }

                                    return (
                                        <div
                                            key={id}
                                            className={classNames(css.item, {
                                                [css.active]: active
                                            })}
                                            onMouseOver={async () => {
                                                store.setCurCategoryIndex(i)
                                                store.curCategoryType = categoryType
                                                store.curCategoryId = id

                                                await fetchCategoryTree({
                                                    categoryType,
                                                    pid: id
                                                })
                                            }}
                                        >
                                            {dom}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                    {/* 子类别 */}
                    {
                        store.showCategoryTreeList &&
                        <div className={css.childCategoryListPanelContainer}>
                            <div className={css.childFloorList}>
                                {
                                    store.categoryTreeList.map((item, i) => {
                                        const {id, name, pid, level, children} = item
                                        return (
                                            <div className={css.childFloor} key={id}>
                                                <div
                                                    className={css.childLevel1Wrapper}
                                                    onClick={() => {
                                                        runInAction(() => {
                                                            toSearchPage({
                                                                keyword: name,
                                                                goodsType: GoodsType.ALL,
                                                                selfFlag: false
                                                            })
                                                            store.setCategoryListFlag(false)
                                                        })
                                                    }}
                                                >
                                                    <div className={css.name}>
                                                        {name}
                                                    </div>
                                                    <div className={css.iconArrowWrapper}>
                                                        <img className={css.iconArrow}
                                                             src={require('./img/分类箭头右.png')}/>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
            }

            {/*输入整块*/}
            <div className={classNames(css.inputContainer, {
                [css.active]: inputFocus
            })}>

                {/*输入框*/}
                <div className={css.inputWrapper}>
                    <input
                        type="text"
                        value={store.keyword}
                        placeholder={store.curHotSearch?.word || ''}
                        onFocus={() => {
                            store.setHotSearchListFlag(true)
                            setInputFocus(true)
                        }}
                        onBlur={() => {
                            store.setHotSearchListFlag(false)
                            setInputFocus(false)
                        }}
                        onChange={e => {
                            store.setKeyword(e.currentTarget.value)
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                toSearchPage({
                                    keyword: store.keyword || store.curHotSearch?.word,
                                    goodsType: store.curGoodsType
                                })
                            }
                        }}
                    />

                </div>

                {/*商品类型显示*/}
                <div className={css.goodsTypeWrapper} onClick={() => store.toggleGoodsTypeListFlag()}>
                    <div className={css.text}>
                        {goodsTypeEnumMap.get(store.curGoodsType)}
                    </div>


                    <img
                        className={css.icon}
                        alt=''
                        src={store.goodsTypeListFlag ? require('./img/商品类型三角上.png') : require('./img/商品类型三角下.png')}
                    />
                </div>

                {/*商品类型选择列表*/}
                {
                    store.goodsTypeListFlag &&
                    <div className={css.goodsTypeList}>
                        {
                            Object.values(goodsType).map(item => {
                                const active = store.curGoodsType === item
                                const text = goodsTypeEnumMap.get(item)

                                let dom;
                                if (active) {
                                    dom = (
                                        <div className={css.spanWrapper}>
                                            <span>{text}</span>
                                        </div>
                                    )
                                } else {
                                    dom = (
                                        <span>
                                                {text}
                                            </span>
                                    )
                                }
                                return (
                                    <div
                                        key={item}
                                        className={classNames(css.item, {
                                            [css.active]: active
                                        })}
                                        onClick={() => {
                                            // 设置商品类型
                                            store.curGoodsType = item

                                            store.setGoodsTypeListFlag(false)
                                        }}
                                    >
                                        {dom}
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {/*热搜列表*/}
                {
                    store.hotSearchListFlag &&
                    <div className={css.hotSearchListPanel}>
                        <div className={css.titleFloor}>
                            <span>热搜词</span>
                        </div>
                        <div className={css.hotSearchList}>
                            {
                                store.hotSearchList.map((item, i) => {
                                    const {id, word} = item
                                    const active = i === store.curHotSearchIndex

                                    let dom;
                                    if (active) {
                                        dom = (
                                            <div className={css.spanWrapper}>
                                                <span>{word}</span>
                                            </div>
                                        )
                                    } else {
                                        dom = (
                                            <span>{word}</span>
                                        )
                                    }

                                    return (
                                        <div
                                            key={id}
                                            className={classNames(css.item, {
                                                [css.active]: active
                                            })}
                                            onMouseOver={() => {
                                                store.setCurHotSearchIndex(i)
                                            }}
                                            onMouseDown={() => {
                                                store.setKeyword(word)
                                                store.setHotSearchListFlag(false)
                                            }}
                                        >
                                            {dom}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }

                {/*搜索按钮*/}
                <button
                    className={
                        classNames(css.btnSearch, {
                            [css.active]: store.hotSearchListFlag
                        })
                    }
                    onClick={() => {
                        toSearchPage({
                            goodsType: store.curGoodsType,
                            keyword: store.keyword || store.curHotSearch?.word
                        })

                    }}
                >
                    <img className={css.icon} src={require('./img/搜索icon.png')} alt=''/>
                </button>

            </div>

            {/*购物车按钮*/}
            <button
                className={classNames(css.btnCart, {
                    [css.active]: cartStore.flag
                })}
                onMouseOver={() => cartStore.setFlag(true)}
                onMouseOut={() => cartStore.setFlag(false)}
                onClick={() => history.push({pathname: MyRouter.Cart.path})}
            >
                <img
                    className={css.iconCart} alt=''
                    src={cartStore.flag ? require('./img/购物车icon-active.png') : require('./img/购物车icon.png')}
                />
                <div className={css.text}>
                    我的购物车
                </div>
            </button>

            {/*抽屉导航按钮*/}
            <button className={css.btnDrawer} onClick={() => drawerStore.toggleFlag()}>
            </button>

            {/*抽屉导航panel*/}
            {
                drawerStore.flag &&
                <div className={css.drawerPanel}>
                    <div className={css.itemList}>
                        {
                            drawer.drawerItemList.map((item, i) => {
                                const {text, onClick} = item
                                const active = i === drawerStore.curIndex

                                let dom;
                                if (active) {
                                    dom = (
                                        <div className={css.spanWrapper}>
                                            <span>{text}</span>
                                        </div>
                                    )
                                } else {
                                    dom = (
                                        <span>
                                            {text}
                                        </span>
                                    )
                                }

                                return (
                                    <div
                                        key={i}
                                        className={classNames(css.item, {
                                            [css.active]: active
                                        })}
                                        onMouseOver={() => {
                                            drawerStore.setCurIndex(i)
                                        }}
                                        onMouseDown={(e) => {
                                            onClick(e)
                                        }}
                                    >
                                        {dom}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default observer(Index)